import { CustomModal, POSButton } from '@publicisgroupe/p-os-components';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NavigationItemDto } from 'types/types';
import { readFilterTagsFromQuery } from '../../utils/helpers';
import './NavigationFilters.less';
import { useTranslation } from 'react-i18next';
import { FilterOptions } from './FilterOptions';

interface NavigationFiltersProps {
  filters: NavigationItemDto[];
  filterNames: string[];
  onFiltersModalClose: () => void;
  showFiltersModal: boolean;
  selectedFiltersChanged: (filters: string[]) => void;
}

export const NavigationFilters = (props: NavigationFiltersProps) => {
  const { filters, filterNames, onFiltersModalClose, showFiltersModal, selectedFiltersChanged } =
    props;
  const location = useLocation();
  const [selectedFilters, setSelectedFilters] = useState<string[]>(
    readFilterTagsFromQuery(location.search)
  );
  const { t } = useTranslation();

  useEffect(() => {
    setSelectedFilters(readFilterTagsFromQuery(location.search));
  }, [filters, location.search]);

  const handleApplyButtonBehavior = (): boolean | undefined =>
    filterNames.length > 0 ? undefined : true;

  const applyModifiedFilters = useCallback(() => {
    const newFilters = [...selectedFilters];
    selectedFiltersChanged(newFilters);
  }, [selectedFilters, selectedFiltersChanged]);

  return (
    <CustomModal
      open={showFiltersModal}
      size="fullscreen"
      className="navigation-filters"
      centered
      onClose={onFiltersModalClose}
      closeOnDimmerClick={false}
      closeOnEscape={false}
    >
      <CustomModal.Content scrolling className="navigation-filters-content">
        {!filterNames.length ? (
          <div className="filter">
            <div className="filter-options">{t('NavigationFiltersNoFilterDataMessage')}</div>
          </div>
        ) : (
          filterNames.map((item: string, levelIndex: number) => (
            <div className="filter" key={`filter-${item}`}>
              <div className="filter-title">{filterNames[levelIndex]}</div>
              <FilterOptions
                levelIndex={levelIndex}
                filterNames={filterNames}
                filters={filters}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />
            </div>
          ))
        )}
      </CustomModal.Content>
      <hr className="divider" />
      <CustomModal.Actions className="navigation-filters-actions">
        <div>
          <POSButton secondary onClick={onFiltersModalClose}>
            {t('Cancel')}
          </POSButton>
          <POSButton
            secondary
            inverted
            disabled={handleApplyButtonBehavior()}
            onClick={applyModifiedFilters}
          >
            {t('Apply')}
          </POSButton>
        </div>
      </CustomModal.Actions>
    </CustomModal>
  );
};
